const TravelAddressComponent = () => import('@/views/finance/TravelAddress/TravelAddressVue')

export default [
    {
        path:'/TravelAddressIndex',
        name:'TravelAddressComponent',
        component:TravelAddressComponent
    }
]